import { useMemo } from "react"


const useTableGradesColumns = () => {
    const columns = useMemo(
        () => [
            {
                accessorKey: 'name',
                header: "שכבה",
            },
            {
                accessorKey: 'classes_len',
                header: "מספר כיתות",
            },
        ], []
    )

    return columns
}

export default useTableGradesColumns